import * as React from 'react';

import { ModalFrame, ModalFrameFooter, ModalFrameInner, ModalFrameMessage } from 'components/modal';
import ActionButton from 'components/buttons/action-button/ActionButton';

type Props = {
  onCloseModal: () => void,
  onExit?: () => void,
  title: string,
  message: string,
  btnText: string,
  align?: 'center' | 'left'
};

class AlertModal extends React.PureComponent<Props> {
  handleClick = () => {
    const { onCloseModal, onExit } = this.props;

    if (onExit) {
      onExit();
    }
    onCloseModal();
  };

  render() {
    const { title, message, btnText, align } = this.props;

    return (
      <ModalFrame
        title={title}
      >
        <ModalFrameInner
          narrowContent
        >
          <ModalFrameMessage
            align={align}
            message={message}
          />
          <ModalFrameFooter>
            <ActionButton
              type="submit"
              color="secondary"
              onClick={this.handleClick}
            >
              {btnText}
            </ActionButton>
          </ModalFrameFooter>
        </ModalFrameInner>
      </ModalFrame>
    );
  }
}

export default AlertModal;
